<script>
  // import wretch from 'wretch';
  import { get } from "$lib/utils/api";
  import Offline from "$lib/components/Offline/Offline.svelte";
  import { goto } from "$app/navigation";
  import { page } from "$app/state";
  import { clientData } from "$lib/client-data/index.svelte.js";
  import { onMount } from "svelte";
  import { usePush } from "$lib/client-data/usePush";
  import "svelte-ripple-action/ripple.css";
  import "../app.css";
  import "animate.css";
  import Layout from "./components/Layout.svelte";
  import { session } from "$lib/client-data/local";

  let { children, data } = $props();
  const maintPush = $state(data.maintPush);

  //获取代理关系
  const getChannel = async () => {
    //机制有点问题，不稳定，暂时用之前的方式
    // const res=await wretch(`/ser/LIVE-MEMBER/noauth/getAgencyPromotionCodeResp?domainUrl=${location.host}`).get().json().catch(()=>{})
    const res = await get(`/LIVE-MEMBER/noauth/getAgencyPromotionCodeResp?domainUrl=${location.host}`);
    // console.log('33333333333333',res)
    if (res.success && res.data.memberAccno) session.channel = res.data.memberAccno;
    const channel = page.url.searchParams.get("channel") || page.url.searchParams.get("inviteCode");
    if (channel) session.channel = channel;
  };
  onMount(async () => {
    usePush("config.maint", "/api/pub/maintPush", maintPush);
    await getChannel();
    //sharetrace
    const appkey = data.shareTrace;
    console.log("sharetrace", data.shareTrace);
    if (appkey) {
      const traceParam = {
        appkey,
        ...(session.channel && { param: "channel=" + session.channel }),
      };
      console.log("traceParam", traceParam);
      ShareTrace.init(traceParam);
    }

    // const aa=await fetch(`/ser/LIVE-MEMBER/noauth/getAgencyPromotionCodeResp?domainUrl=${encodeURIComponent('9b001.com')}`,{method:'GET'}).then(p=>p.json())
  });
  $effect(() => {
    //维护状态的全局处理
    if (!maintPush.maintainStatus && page.url?.pathname?.startsWith("/maintain")) goto("/", { replaceState: true });
    if (maintPush.maintainStatus && !page.url?.pathname?.startsWith("/maintain")) goto("/maintain", { replaceState: true });
  });
  clientData.apiConfig = data.env;
  clientData.deviceId = data.deviceId;
  clientData.assets = data.assets;
  clientData.texts = data.texts;
  clientData.theme = data.theme;

  // let isAuthPage = $derived.by(() => page.url?.pathname?.startsWith("/auth"));
</script>

<svelte:head>
  <link rel="icon" href={data.assets?.logoApp} />
  <link rel="manifest" href="/ser/manifest" />
  <title>{data.texts?.name}</title>
  <link rel="apple-touch-icon" href={data.assets?.logoApp} />
  <meta property="og:image" content={data.assets?.logoApp} />
  <link rel="apple-touch-startup-image" href={data.assets?.login_logo} />
  <meta name="apple-mobile-web-app-title" content={data.texts?.name} />
  <meta property="og:description" content={data.texts?.name + "是最大的综合博彩网站"} />
  <script async src="https://res.sharetrace.com/sharetrace.min.js"></script>
  {#if data.env?.baidu}{@html `
    <script>
      var _hmt = _hmt || [];
      (function() {
        var hm = document.createElement("script");
        hm.src = "//hm.baidu.com/hm.js?${data.env.baidu}";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    </script>
  `}{/if}
  {#if data.env?.cnzz}{@html `
    <script>
      var _czc = _czc || [];
      (function () {
        var um = document.createElement("script");
        um.src = "https://v1.cnzz.com/z.js?id=${data.env.cnzz}&async=1";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(um, s);
      })();
    </script>
  `}{/if}
</svelte:head>
<Offline></Offline>
<!-- {#if isAuthPage}
  {@render children?.()}
{:else}
  
{/if} -->
<Layout {data} {children} />
